/* eslint-disable react/destructuring-assignment */
import React, { Component } from '@ali/odin/react';
import Markdown from './../Component/markdown';
import styles from '../index.less';


const markdown = 
`
## 优酷互动内容服务

优酷的互动内容服务，由优酷互动内容平台（Youku Interactive Content Platform，简称 YICP），优酷互动引擎（Youku Interactive Engine，简称YIE），和优酷互动播放系统（Youku Interactive Playing System，简称YIPS）三部分构成。

- 优酷互动内容平台，是优酷为内容创作者和开发者提供的互动内容全流程管理平台，将故事线设定、素材制作、效果预览、内容审核、版本管理等流程标准化，为内容创作者提供服务保障；
- 优酷互动引擎，通过将玩法标准化，支持内容创作者快速定制个性化互动玩法组件，并且通过将终端技术实现模块化，为互动播放平台的互动玩法提供底层支持；
- 优酷互动播放系统，可基于互动引擎灵活配置相关的互动玩法组件，适配多终端场景的观看体验，并采集观看数据和用户反馈以供后续内容改进。

![img](https://img.alicdn.com/tfs/TB1pduXe1H2gK0jSZJnXXaT1FXa-1800-1102.png)

### 

## 优酷互动内容平台（YICP）

### 平台账号开通

#### 1、账号类型

根据创作能力的不同，平台将账号分为 创作者账号 和 开发者账号 两类：

- 创作者账号，可在平台上传互动内容素材，构建互动情节逻辑，发布互动内容节目；
- 开发者账号，可依靠平台提供的开放接口，提交自定义互动组件，支持互动内容中互动方式的实现。

本章重点描述创作者账号相关功能，如需了解开发标准请查看 **[优酷互动内容技术标准](./index.html?index=3)**。

#### 2、申请开通

平台账号申请流程如下：

![img](https://img.alicdn.com/tfs/TB1HmGrbVT7gK0jSZFpXXaTkpXa-1800-490.png)

*※ 详细申请流程将稍后随YICP平台上线时统一发布。*

### 内容创作流程

平台将为内容创作者提供以下能力：

- **内容管理：**上传/管理节目和素材文件，定义名称、封面、描述等信息，管理发布版本；

- **故事线设定：**管理故事线的内容和互动分支，实现逻辑数值判断和玩法设定等；

- **效果预览：**预览确认互动内容镜头衔接是否得当、剧情逻辑是否合理、播放观感是否流畅等；

- **内容审核：**提供内容初审支持，确保互动内容符合国家相关政策法规和优酷内容价值观；

- **对外发布：**跨平台将审核通过的内容一键发布到各类终端展示，实现全网推送；

- **数据分析：**提供节目观看数据及用户反馈供创作者改进内容。

#### 

如需自定义玩法能力请点击查看 **[优酷互动内容技术标准](./index.html?index=3)**。

####  

## 优酷互动引擎（YIE）

### 互动组件定制

为创作者定制个性化互动玩法组件提供的上层编辑工具。在编辑工具上，创作者只需要简单拖动，将不同的系统功能模块组织在一起，快速实现前端互动播放效果，并修改模块上的参数，定制不同模块的个性化组件参数，然后一键导入定制后的互动组件，应用到故事呈现中。

### 接口封装

为其他系统提供一套完整的互动通信接口。通过将底层互动能力抽象，将底层框架的主要结构和流程封装，使得内部修改不影响外界其他模块与其交互的方式，一次接入，降低二次开发时底层模块接入复杂度，快速完成个性化互动玩法的实现，轻松支持丰富多样的流程化定制和开发。

## 优酷互动播放系统（YIPS）

### 互动播放器

#### 1、半屏播放器

进入互动内容详情页后，默认在竖屏状态，显示视频封面图、互动播放按钮等。半屏播放器中点击互动播放，切换到全屏状态。

![img](https://img.alicdn.com/tfs/TB1XiWxbYY1gK0jSZTEXXXDQVXa-1800-1308.png)

#### 2、全屏播放器

全屏播放器上可显示播放暂停、时间轴、清晰度、分享、剧情地图、彩蛋入口等功能。

![img](https://img.alicdn.com/tfs/TB1OQK7b4D1gK0jSZFyXXciOVXa-1800-1102.png)

##  

### 互动组件

互动内容中允许用户进行互动的能力组件（例如分支剧情、视角切换、画面信息探索等），互动能力通过互动组件实现。丰富的互动组件可以为内容创作者提供多种快捷可配置的互动玩法，让视频具备相应互动能力或实现播放逻辑判断。

#### 1、剧情分支组件

该互动能力支持观众基于自身立场或偏好进行剧情选择。播放到剧情关键节点时，本组件可以为观众设置2~4个互动选项，观众做出选择后则进入到对应分支剧情或对应结局。分支剧情组件分为“倒计时选择”和“打断式选择”两类。

##### 用户价值

观众基于自身立场或偏好进行选择并影响剧情发展，使用户在抉择与改变中获得成就与快感。

##### 举例说明

##### a. 倒计时选择

互动效果说明：用户进入互动点时出现选项，并开始计时，如在倒计时结束前用户选择某选项，则进入对应情节，如倒计时结束时也未选择，则进入预设的默认选项。
![img](https://img.alicdn.com/tfs/TB15gHwgKH2gK0jSZJnXXaT1FXa-1800-1102.gif)

##### b. 打断式选择

互动效果说明：当出现互动点时会暂停画面，直至用户做出选择后进入对应剧情。
![img](https://img.alicdn.com/tfs/TB1y5frgKT2gK0jSZFvXXXnFXXa-1800-1102.png)

##### 使用场景建议

常用剧情为两难抉择、剧情高潮点或转折点等。

#### 2、数值组件

该互动能力支持内容创作者用“数值”累计观众在较长时间跨度内的一系列互动操作，并通过赋值的方法继承观众每一次互动操作所表现出的倾向性，最终通过“数值”在观众所选择的分支剧情下的累计值触发相应剧情发展。赋值的方法包括但不限于增加、减少、倍数和随机数等，由内容创作者结合剧情实际需要选择应用。

##### 用户价值

数值具有综合反馈多次互动操作结果的优势，是让内容更了解观众，并根据不同的观众喜好进行个性化的内容供给。数值能够让观众互动操作与内容反馈间的关联更具多样性，以此提升互动结果的个性化和真实感。

##### 举例说明

##### a. 道具收集

互动效果说明：观众通过与画面中的物体进行互动收集，获得对应的数值状态变化，从而获得内容彩蛋或者影响下一步剧情发展。物品主要为剧情中的核心道具，包括宝藏、武功秘籍、武器装备等。
![img](https://img.alicdn.com/tfs/TB1Iiq6bQL0gK0jSZFAXXcA9pXa-1800-1102.png)

##### b. 彩蛋

互动效果说明：支持提前在视频中插入一些能给观众带来“惊喜”的隐藏内容，通过让用户发现并与这些彩蛋内容产生互动，获得对应数值奖励，从而解锁更多的主线剧情以外的故事。
![img](https://img.alicdn.com/tfs/TB18aa4bG67gK0jSZFHXXa9jVXa-1800-1102.png)

##### c. 小游戏

互动效果说明：在互动内容的节点添加小游戏环节，让观众在观影的同时，通过游戏操控角色的反应动作并根据结果获得打分数值，提升观众的剧情代入感和成就感。
![img](https://img.alicdn.com/tfs/TB1DOu7bHj1gK0jSZFuXXcrHpXa-1800-1102.png)

##### 使用场景建议

让观众纠结的感情戏；需要通过长期积累（多次互动）才能决定剧情；需要推出符合观众意向的结局剧情。

#### 3、即时反应组件

观众观看到关键剧情时，按画面提示进行即时互动动作。常见的即时互动动作包括：点击、连续点击、长按、左滑、右滑、上滑和下滑、晃动手机。例如剧情中出现落石时，观众可以通过左滑或右滑动作帮助男主角躲闪；剧情中出现举杯敬酒时，观众可以操作上滑动作帮助男主角完成举杯。

##### 用户价值
观众通过即时动作操作剧中角色动作的实施，或者影响剧情情节的发展，在深度参与中获得沉浸体验。
##### 举例说明

##### a. 点击

互动效果说明：点击画面中人物或物体，实现互动效果。
![img](https://img.alicdn.com/tfs/TB1IGW6bNn1gK0jSZKPXXXvUXXa-1800-1102.png)

##### b. 连续点击

互动效果说明：连续点击屏幕区域，触发互动效果。
![img](https://img.alicdn.com/tfs/TB1dOS4bUY1gK0jSZFMXXaWcVXa-1800-1102.gif)

##### c. 长按

互动效果说明：长按屏幕区域，触发互动效果。
![img](https://img.alicdn.com/tfs/TB1w91jb4D1gK0jSZFsXXbldVXa-1800-1102.gif)

##### d. 滑动

互动效果说明：左滑或右滑屏幕区域，触发互动效果。
![img](https://img.alicdn.com/tfs/TB1yyy7bHj1gK0jSZFuXXcrHpXa-1800-1102.gif)

##### e. 摇晃

互动效果说明：通过持续晃动手机，触发互动效果。
![img](https://img.alicdn.com/tfs/TB1qti7bQL0gK0jSZFxXXXWHVXa-1800-1102.png)

##### 使用场景建议

需要观众引导剧中人物进行复杂动作行为时（例：角色打斗时）。

#### 4、自定义互动组件

自定义互动组件，允许内容开发者通过开放接口，上传组件各模块开发要素。当前平台开放自定义互动组件开发，逐步推进中，如了解详情请点击查看 **[优酷互动内容技术标准](./index.html?index=3)**。
`

class Make extends Component<{
  onChange: (obj: any) => void;
}> {
  constructor(props) {
    super(props);
  }
  render() {
    return <section className={styles.doc}>
      <Markdown markdown={markdown} title={'优酷互动视频创作标准'} onChange={this.props.onChange}/>
    </section>
  }
}

export default Make;
